import React from 'react';

function TextInput(props) {
    return (
        <input type="number" className="form-control" {...props} />
    );
}

export default TextInput;